// extracted by mini-css-extract-plugin
export default {"view-item-video":"view-item-video--1f-Fp","viewItemVideo":"view-item-video--1f-Fp"};